export default __webpack_public_path__ + "static/media/astro-scene_2.10593ec5.png";